import InstantNoti from './instant_noti.js'
import Quickview from './quickview.js'
import ConversationModal from './conversation_modal.js'
const LoadOrderModal = () => import(/*webpackChunkName: "order-modal" */ './product/order_modal.js') // very heavy
import AskNotification from './ask_notification.js'
const sb = require('@sb/util')
import sw from '../subiz/store/sw.js'
import store from '@sb/store'

import Toaster from './commons/toaster.js'
import Confirm from './commons/confirm.js'
import CallModal from './call_modal.js'
import GlobalAudioPlayer from './commons/global_audio.js'

import InternalChat from './internal_chat/internal_chat.js'

import MessageTemplateEditModal from './activities/message_template_edit_modal.js'
import ManageMessageTemplateModal from './activities/manage_message_template_modal.js'
import TaskDetailModal from './commons/task_modal.js'
import NotiMessageManager from './noti_message_manager.js'

const MESSAGE_TEMPLATES_LIMIT = 100
import HeaderBar from './header.js'
import TasksModal from './commons/tasks_modal.js'
import OnboardingModal from './onboarding_modal.js'
import Fragment from '@sb/com/fragment.js'
import UpdateContact from './commons/update_contact.js'
import SendEmailWindows from './commons/global_emails_manager.js'
import Icon from '@sb/com/icon.js'
import {isTicketImportantUnread} from './ticket/com.js'
import NotiBar from './noti_bar.js'
import EditTicketModal from './ticket/edit_tickket_modal.js'
import ChurnedModal from './expired_modal.js'
import ExpiredTokenModal from './expired_token_modal.js'

export default {
	name: 'mainlayout',
	data() {
		return {
			notifies: {},

			isShowQuickview: false,
			isShowConversationModal: false,

			quickviewUcid: '',
			quickviewMessage: '',

			// manage message_template_edit_modal
			editMessageTemplate: {},
			listMsgTemplateChannelType: '',
			isMessageTemplateManageModalOpenned: false,
			msgTemplateKeyword: '',
			msgTemplateTab: 'all_template',
			page: 1,

			isShowChurned2Content: false,

			showEditTicketModal: false,
			newTicket: {id: 'new'},
		}
	},

	mounted() {
		window.$router = this.$router
		this.$root.$on('message_template_modal_open', this.openManageMessageTemplateModal)
		this.$root.$on('open_ticket', this.openTicket)
		this.$root.$on('open_edit_ticket_modal', this.openEditTicketModal)

		let quickview = sb.getUrlParameter(document.location.href, 'quickview')
		if (quickview) {
			let user_id = quickview.split('%')[0]
			let convo_id = quickview.split('%')[1]
			let create_new = quickview.split('%')[2]
			this.onShowQuickview({show: true, user_id, convo_id, create_new})
		}
		if (lo.get(this.$route, 'query.message_template')) this.isMessageTemplateManageModalOpenned = true
		store.onConvo(this, (_) => this.changeDocumentTitle())
		store.onRoute(this, () => this.$forceUpdate())

		this.computeShouldShowChurned2Content()
		this.showNotiPayment()

		store.playNotificationSound()
		store.detectUnLoadTab()

		if (store.shouldShowOnboarding2()) {
			console.log('MAIN LAYOUTTTTTT MOUNTEDDD')
			//store.markOnboardingRedirected() // change language trigger mounted so dont reidrect for this case
			//if (lo.get(this.$route, 'name') !== 'onboarding2') {
			//this.$router.push({name: 'onboarding2'})
			//}
		}
	},

	watch: {
		$route(to, from) {
			if (this.notifies.error) {
				this.notifies = {}
			}
			this.changeDocumentTitle()
			this.handleRedirect()
		},
	},

	methods: {
		openTicket(p) {
			let ticket = store.matchTicket(p.ticket_id)
			this.$router.push({path: '/tickets/' + (ticket.number || p.ticket_id)})
		},

		handleBeforeUnload(event) {
			// event.preventDefault();
			event.returnValue = ''
			window.myLocalStorage.setItem('sound_master', null)
		},
		countConvoUnread() {
			let seen = lo.get(store.me(), 'dashboard_setting.conversation_seen', 0)
			let topics = store.listTopics(5_000)
			return lo.filter(topics, (topic) => {
				if (topic.actived <= seen) return false
				if (sb.isTopicIdConvo(topic.id)) return !topic.read
				return isTicketImportantUnread(store.matchTicket(topic.id) || {id: topic.id})
			}).length
		},

		async showNotiPayment() {
			let reses = await Promise.all([store.fetchInvoices(), store.listCredits()])
			let mktData = lo.get(reses, '1.body.credits')
			mktData = lo.find(mktData, (credit) => credit.id === 'marketing') || {}

			let mktCredit = lo.get(mktData, 'fpv_balance', 0)
			let unpaidInvoices = lo.filter(store.matchInvoice(), (invoice) => invoice.state === 'open')
			let isOverdue = lo.find(unpaidInvoices, (invoice) => Date.now() > sb.getMs(invoice.due_date))

			// show invoice within 7 days for owner and manager, if more than 7 days show all agents
			const SHOW_ALL_AGENTS_TIME = 7 * 24 * 3_600_000
			let createds = lo.map(unpaidInvoices, (invoice) => sb.getMs(invoice.created))
			let minCreated = lo.min(createds)
			let shouldShowForMe = false
			if (minCreated) {
				if (Date.now() - minCreated > SHOW_ALL_AGENTS_TIME) {
					shouldShowForMe = true
				} else {
					let acc = store.me().account
					let scopes = lo.get(store.me(), 'scopes') || []
					shouldShowForMe =
						acc.owner_id == store.me().id ||
						lo.includes(scopes, 'owner') ||
						lo.includes(scopes, 'account_manage') ||
						lo.includes(scopes, 'account_setting')
				}
			}

			if (!shouldShowForMe) return
			if (isOverdue || mktCredit < 0) {
				let title = this.$t('mkt_credit_noti_title')
				let description = this.$t('mkt_credit_noti_desc')
				if (isOverdue) {
					title = this.$t('overdue_invoice_noti_title')
					description = this.$t('overdue_invoice_noti_desc')
				}
				this.$root.$emit('push_noti_message', {
					id: 'payment_noti',
					priority: 'high',
					type: 'danger',
					title,
					description,
					primary_button: {
						label: this.$t('pay_now'),
						onclick: () => {
							this.$router.push({name: 'settings.subscription-info'})
							this.$root.$emit('remove_noti_message', 'payment_noti')
						},
					},
				})
			} else if (lo.size(unpaidInvoices)) {
				this.$root.$emit('push_noti_message', {
					id: 'payment_noti',
					priority: 'high',
					type: 'warning',
					title: this.$t('unpaid_invoice_noti_title'),
					description: this.$t('unpaid_invoice_noti_desc'),
					primary_button: {
						label: this.$t('pay_now'),
						onclick: () => {
							this.$router.push({name: 'settings.subscription-info'})
							this.$root.$emit('remove_noti_message', 'payment_noti')
						},
					},
				})
			}
		},

		changeDocumentTitle: lo.throttle(
			function () {
				let title = this.$t(lo.get(this.$route, 'meta.title', 'Subiz'))
				if (!store.me().id) {
					document.title = title
					return
				}
				let count = this.countConvoUnread()

				var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
				link.type = 'image/x-icon'
				link.rel = 'shortcut icon'
				link.href = '/favicon.ico'
				if (count > 0) {
					title = this.$t('unread_convo_and_users', [count])
					link.href = '/favicon_unread.ico'
				}
				document.getElementsByTagName('head')[0].appendChild(link)
				document.title = title
			},
			500,
			{leading: false},
		),

		onShowConversationModal(param) {
			if (!param.url) {
				this.isShowConversationModal = false
				this.conversationModalUrl = ''
				this.conversationModalViewId = undefined
				this.conversationModalUserId = undefined
				return
			}

			this.isShowConversationModal = true
			this.conversationModalUrl = param.url
			this.conversationModalViewId = param.view_id
			this.conversationModalUserId = param.user_id
		},

		onShowQuickview(param) {
			if (param.show === false) {
				this.isShowQuickview = false
				this.quickviewUcid = ''
				return
			}

			let create_new = param.create_new == true || param.create_new == 'true'
			this.quickviewUcid = (param.user_id || '') + '%' + (param.convo_id || '') + '%' + create_new
			this.quickviewMessage = param.message || ''
			this.isShowQuickview = true
		},

		async onShowQuickOrderView(param) {
			let currentRouter = lo.get(this.$router, 'currentRoute', {})
			if (currentRouter.name === 'order-list') return
			return this.$showOrder({id: param.id})
		},

		removeToaster(type) {
			this.notifies[type] = {}
		},

		async onLogout() {
			if (process.env.ENV !== 'app') {
				let serviceWorker = await sw.serviceWorker()
				await serviceWorker.postMessage({type: 'logout'})
			}
			const currentRouterName = lo.get(this.$route, 'path', '/')
			this.$router.push({name: 'login', query: {redirect: currentRouterName}})
		},

		renderPopup() {
			let $notifies = lo.map(this.notifies, (notify) => {
				if (lo.isEmpty(notify)) return null
				return (
					<div class='popup_notification__item'>
						<Toaster
							type={notify.type}
							title={notify.title}
							description={notify.description}
							timeout={notify.timeout}
							action={notify.action}
							vOn:onClose={this.removeToaster}
						/>
					</div>
				)
			})
			return <div class='popup_notification'>{$notifies}</div>
		},

		addParamsToLocation(params) {
			let url = new URL(window.location.href)
			lo.each(params, (value, key) => {
				if (value) {
					url.searchParams.set(key, value)
				} else {
					url.searchParams.delete(key)
				}
			})
			window.history.pushState({}, null, url.href)

			return
			history.pushState(
				{},
				null,
				this.$route.path +
					'?' +
					Object.keys(params)
						.map((key) => {
							return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
						})
						.join('&'),
			)
		},

		openManageMessageTemplateModal(channelType) {
			this.isMessageTemplateManageModalOpenned = true
			let query = lo.get(this.$route, 'query', {})
			this.addParamsToLocation({...query, message_template: true})
			this.listMsgTemplateChannelType = channelType
		},

		closeManageMessageTemplateModal() {
			this.isMessageTemplateManageModalOpenned = false
			let currentQuery = lo.get(this.$route, 'query', {})
			currentQuery.message_template = ''
			this.addParamsToLocation(currentQuery)
		},

		renderMessageTeplatesManageModal() {
			return (
				<ManageMessageTemplateModal
					open={this.isMessageTemplateManageModalOpenned}
					vOn:edit={(msgtmpl) => (this.editMessageTemplate = msgtmpl)}
					vOn:close={() => this.closeManageMessageTemplateModal()}
				/>
			)
		},

		onSubmitMessageTemplate() {
			this.editMessageTemplate = {}
			this.$forceUpdate()
		},

		computeShouldShowChurned2Content() {
			const CHURN_2_EXPIRED_MILISECS = 15 * 24 * 3_600_000
			let subscription = store.matchSubscription()
			if (!subscription) {
				this.isShowChurned2Content = false
				return false
			}
			this.isShowChurned2Content = subscription.churned && Date.now() - subscription.churned > CHURN_2_EXPIRED_MILISECS
		},

		renderChurned2Content() {
			let acc = store.me().account
			let owner = store.matchAgent()[acc.owner_id]
			return (
				<div class='w_100 h_100 d-flex align-items-center justify-content-center'>
					<div class='text__center' style='width: 500px'>
						<Icon name='alert-triangle-filled' size='80' class='mb-4 text__secondary' />
						<div class='text__xl text__uppercase mb-3'>{this.$t('your_account_will_be_deleted')}</div>
						{store.me().id === acc.owner_id ? (
							<Fragment>
								<div class='text__muted text__lg'>
									{this.$t('churned2_warning_for_owner', [lo.get(store.me(), 'account.name', this.$t('you'))])}{' '}
								</div>
								<div class='mt-4'>
									<button
										type='button'
										class='btn btn__primary btn__lg'
										style='width: 250px'
										vOn:click={() => this.$root.$emit('expandWidget')}
									>
										{this.$t('chat_with_subiz2')}
									</button>
								</div>
								<div class='mt-4 text__lg'>
									<a href='tel:02473021368'>
										{this.$t('call_to_subiz_hotline')} {'024 7302 1368'}
									</a>
								</div>
							</Fragment>
						) : (
							<div class='text__muted text__lg'>
								{this.$t('churned_warning_for_agent', [
									lo.get(store.me(), 'account.name', this.$t('you')),
									lo.get(owner, 'email', 'support@subiz.com'),
								])}
							</div>
						)}
					</div>
				</div>
			)
		},

		pushNotiMessage(params) {
			this.$root.$emit('push_noti_message', params)
		},

		openEditTicketModal(convo_id, uid) {
			let newTicket = {id: 'new', users: [{id: uid}]}
			if (sb.isTopicIdConvo(convo_id)) {
				newTicket.associated_conversations = [convo_id]
			}
			this.newTicket = newTicket
			this.showEditTicketModal = true
		},

		handleRedirect() {
			let path = lo.get(this.$route, 'path')
			console.log('handleRedirectttttttttttt pathname', lo.get(this.$route, 'path'))
			if (path === '/') {
				if (store.shouldShowOnboarding2()) {
					this.$router.replace({name: 'onboarding2'})
				} else {
					this.$router.replace({name: 'activities'})
				}
			}
		},
	},

	created() {
		store.onLogout(this, () => this.onLogout())
		this.changeDocumentTitle()
		this.$root.$on('_popup_notify', (notify) => {
			this.$set(this.notifies, notify.type, notify)
		})
		this.$root.$on('showQuickview', this.onShowQuickview)
		this.$root.$on('showConversationModal', this.onShowConversationModal)
		this.$root.$on('showOrder', this.onShowQuickOrderView)

		window.pushNotiMessage = this.pushNotiMessage

		setTimeout(() => {
			store.onDocument(this, 'keydown', (e) => {
				if (e.key !== 'Escape') return
				if (this.isShowQuickview) return this.onShowQuickview({show: false})
				if (this.isShowConversationModal) return this.onShowConversationModal({url: ''})
			})
		}, 100)
		this.handleRedirect()
	},

	beforeDestroy() {
		this.$root.$off('showQuickview', this.onShowQuickview)
		this.$root.$off('showConversationModal', this.onShowConversationModal)
		this.$root.$off('showOrder', this.onShowQuickOrderView)
	},

	render() {
		if (this.isShowChurned2Content) {
			return (
				<div class='root'>
					<div class='root__header'>
						<HeaderBar routerName={this.$route.name} ref='header_bar' />
					</div>
					<div class='root__body'>
						<div class='root_content'>{this.renderChurned2Content()}</div>
						<InternalChat />
					</div>
				</div>
			)
		}
		let routeloading = store.matchRouteLoading()
		let $content = (
			<keep-alive include='lead'>
				<router-view></router-view>
			</keep-alive>
		)
		let isSettings = (lo.get(this.$route, 'name') || '').startsWith('settings')
		if (routeloading && !isSettings) $content = <Spinner size='20' class='mt-4 ml-4' mode='blue' />

		let $globalEmail = null
		let availableFromEmail = lo.find(
			sb.getAllEmail(),
			(email) => !email.outbound_disabled && email.verification_status === 'SUCCESS',
		)
		if (availableFromEmail) {
			$globalEmail = (
				<div
					class='global_email_button'
					vOn:click={() => this.$root.$emit('show_global_email', {subject: '', from: '', to: ''})}
				>
					<Icon name='mail-filled' size='20' />
				</div>
			)
		}

		return (
			<div class='root'>
				<div class='root__header'>
					<AskNotification />
					<NotiBar />
					<HeaderBar routerName={this.$route.name} ref='header_bar' />
				</div>
				<InstantNoti />
				<NotiMessageManager />
				<div class='root__body'>
					{this.renderPopup()}
					<Confirm />
					<UpdateContact />
					<div class='root_content'>
						{$content}
						<Quickview show={this.isShowQuickview} ucid={this.quickviewUcid} />
						<ConversationModal
							show={this.isShowConversationModal}
							url={this.conversationModalUrl}
							view_id={this.conversationModalViewId}
							user_id={this.conversationModalUserId}
						/>
						<OrderModalComponent cid={this.cid} />
					</div>
					<InternalChat quickviewUcid={this.quickviewUcid} isShowQuickview={this.isShowQuickview} />
				</div>
				{this.renderMessageTeplatesManageModal()}
				<MessageTemplateEditModal
					message_template={this.editMessageTemplate}
					vOn:close={(_) => (this.editMessageTemplate = {})}
					vOn:change={(msgtmpl) => (this.editMessageTemplate = msgtmpl)}
					vOn:success={this.onSubmitMessageTemplate}
				/>
				{$globalEmail}
				<CallModal />
				<GlobalAudioPlayer />
				<AgentsModal />
				<TasksModal />
				<TaskDetailModal />
				<OnboardingModal />
				<SendEmailWindows />
				<ChurnedModal />
				<ExpiredTokenModal />
				<EditTicketModal
					ticket={this.newTicket}
					open={this.showEditTicketModal}
					vOn:success={(ticket) => {
						this.$forceUpdate()
						this.$root.$emit('update_user_ticket_tab_id', ticket)
					}}
					vOn:close={() => (this.showEditTicketModal = false)}
				/>
			</div>
		)
	},
}

var AgentsModal = {
	data() {
		return {
			isAgentModalOpened: false,
			agent_keyword: '',
			waiting: false,
			call_to: '',
		}
	},

	mounted() {
		this.$root.$on('agent_modal_open', this.openAgentModal)
		store.onAccount(this, (payload) => {
			if (lo.get(payload, 'object_type') === 'agent') {
				this.$forceUpdate()
			}
		})
	},

	methods: {
		openAgentModal() {
			this.isAgentModalOpened = true
		},

		closeAgentModal() {
			this.isAgentModalOpened = false
		},

		renderAgents() {
			let agents = this.getFilteredAgents()

			let $item = []
			lo.map(agents, (item) => {
				$item.push(<div>{this.renderAgentContent(item)}</div>)
			})

			return $item
		},

		async makeCall(number) {
			this.waiting = true
			await store.makeWebCall(number)
			this.waiting = false
			if (!this.waiting) this.closeAgentModal()
		},

		renderAgentContent(item) {
			let $dot_status = <div class='status_agent_dot call_online_dot' style='bottom: -2px; left: 30px'></div>
			let $status = <span style='color: #19B600'>{this.$t('status_online')}</span>
			let lastPing = lo.get(item, 'last_seen.pinged', 0)
			if (Date.now() - lastPing > 30000) {
				$dot_status = <div class='status_agent_dot call_unavailable_dot' style='bottom: -2px; left: 30px'></div>
				$status = <Time ago has_suffix time={lastPing} />
			}
			let $call_icon_btn = (
				<div style='width: 60px; height: 32px;'>
					<Icon name='phone' class='phone_fill_icon' stroke-width='2' size='16' />
					<span style="font-family: 'Inter'; font-style: normal; font-weight: 500; font-size: 16px; line-height: 19px; color: #FFFFFF; margin-left: 5px;">
						{this.$t('call_short')}
					</span>
				</div>
			)

			if (this.waiting && this.call_to == item.id)
				$call_icon_btn = (
					<div style='height: 32px'>
						<Spinner size='18' mode='light' />
					</div>
				)

			let avatar_url = item.avatar_url
			if (!item.avatar_url) avatar_url = sb.getAgentDefaultAvatarUrl(item)

			let bg_cls = 'width: 62px; padding: 0;'
			let btn_tooltip = ''
			if (item.dashboard_setting.on_call != '' && item.dashboard_setting.on_call) {
				bg_cls += 'background: #ffc107; border-color: #ffc107;'
				btn_tooltip = this.$t('on_call')
			}

			return (
				<div class='d-flex align-items-center' style='margin-bottom: 5px; height: 52px'>
					<div style='position: relative;'>
						<img2 src={avatar_url} class='dropdown_item_img' style='width: 40px; height: 40px; border-radius: 50%' />
						{$dot_status}
					</div>
					<div class='ml-3 dropdown_item_text' style='flex: 1; color: black; flex-direction: column'>
						<div class='text__truncate' style='width: 105px; font-size: 16px; font-weight: 500'>
							{item.fullname}
						</div>
						<div class='text__truncate text__muted' style='font-size: 14px; font-weight: 400'>
							{$status}
						</div>
					</div>
					<div style='margin-right: 5px; margin-left: 15px;'>
						<span style='font-size: 16px; font-weight: 400;'>{item.extension}</span>
					</div>
					<div>
						<button
							type='button'
							class='btn btn__lg btn__success ml-3'
							vOn:click={() => {
								this.call_to = item.id
								this.makeCall(item.extension)
							}}
							style={bg_cls}
							disabled={this.waiting}
							v-tooltip={btn_tooltip}
						>
							{$call_icon_btn}
						</button>
					</div>
				</div>
			)
		},

		onChangeKeyword(val) {
			this.agent_keyword = val
		},

		renderAgentFilter() {
			let searchcls = 'form-control input_search__input order_filter_search_input'
			return (
				<div class='input_search lead_mgr_filter_wrapper' style='margin: 10px 15px;'>
					<Icon name='x' size='1x' class='input_search__icon_search' />
					<input
						placeholder={this.$t('find_by_keyword')}
						ref='search_input'
						class={searchcls}
						style='padding-left: 35px;'
						value={this.agent_keyword}
						vOn:input={(e) => this.onChangeKeyword(e.target.value)}
					/>
					{this.agent_keyword && (
						<div
							class='order_filter_x'
							vOn:click={() => this.onChangeKeyword('')}
							style='position: absolute; right: 10px'
						>
							&times;
						</div>
					)}
				</div>
			)
		},

		getFilteredAgents() {
			let me = store.me()
			let agents = lo.filter(
				store.matchAgent(),
				(agent) => agent.type === 'agent' && agent.state === 'active' && agent.id != me.id,
			)
			agents = lo.orderBy(agents, ['created'], ['desc'])
			agents = lo.filter(agents, (item) => {
				let keywordFilter = true
				if (this.agent_keyword) {
					let keyword = sb.unicodeToAscii(this.agent_keyword).toLowerCase()
					let name = sb.unicodeToAscii(item.fullname || '').toLowerCase()
					let extension = sb.unicodeToAscii(item.extension || '')
					keywordFilter = name.indexOf(keyword) >= 0 || extension.indexOf(keyword) >= 0
				}
				return keywordFilter
			})
			return agents
		},
	},

	render() {
		if (!this.isAgentModalOpened) return null
		let totalAgent = lo.size(
			lo.filter(
				store.matchAgent(),
				(agent) => agent.type === 'agent' && agent.state === 'active' && agent.id != store.me().id,
			),
		)

		let totalFilteredAgent = lo.size(this.getFilteredAgents())
		let result = `${totalFilteredAgent}/${totalAgent}`
		if (!this.agent_keyword) result = totalAgent

		let $content = (
			<div style='overflow-y: scroll; height: 272px; padding-left: 15px; padding-right: 6px;'>
				{this.renderAgents()}
			</div>
		)
		if (totalFilteredAgent == 0)
			$content = (
				<div class='text__muted' style={'display: flex; height: 272px; justify-content: center; align-items: center'}>
					<p>{this.$t('no_agents')}</p>
				</div>
			)

		return (
			<div
				class='modal'
				style='cursor: autop; padding-top: 44px; padding-right: 30px; align-items: flex-start; justify-content: flex-end;'
			>
				<div class='modal__overlay' vOn:click={this.closeAgentModal} />
				<div class='modal__container'>
					<div class='modal__background'>
						<div class='modal_content' style='padding-top: 15px; width: 325px; height: 365px;'>
							<div class='d-flex' style='padding-left: 15px; padding-right: 15px;'>
								<div style="flex: 1; font-family: 'Inter'; font-style: normal; font-weight: 500; font-size: 18px; line-height: 22px;">
									{this.$t('agent')} ({result})
								</div>
								<Icon name='x' class='x-icon ml-auto' size='24' vOn:click={this.closeAgentModal} />
							</div>
							{this.renderAgentFilter()}
							{$content}
						</div>
					</div>
				</div>
			</div>
		)
	},
}

var OrderModalMethod = {}

let g_register = false
var _order = {}
var _showing = null
var _option = {}

OrderModalMethod.install = (Vue) => {
	Vue.prototype.$isShowOrder = () => !!_showing
	Vue.prototype.$order = () => _order
	Vue.prototype.$orderOption = () => _option
	Vue.prototype.$showOrder = function (param, option) {
		if (!g_register) {
			this.$root.$on('order_modal_updated', (order) => {
				if (order == undefined) _order = {id: _order.id}
				else _order = Object.assign({}, _order, order)
			})

			this.$root.$on('order_modal_closed', () => {
				if (_showing) _showing(_order)
				_showing = null
			})
		}
		g_register = true

		// close the opening order first
		if (_showing) _showing(_order)

		_order = param || {}
		_option = option
		_showing = null

		this.$root.$emit('order_modal_open')
		if (!param) return Promise.resolve()
		return new Promise((rs) => (_showing = rs))
	}
}

Vue.use(OrderModalMethod)
var OrderModalComponent = {
	props: ['cid'],
	created() {
		this.$root.$on('order_modal_open', () => this.$forceUpdate())
		setTimeout(async () => {
			this.OrderModal = await LoadOrderModal()
			this.$forceUpdate()
		})
	},

	methods: {
		onChangeOrder(order) {
			this.$root.$emit('order_modal_updated', order)
			this.$forceUpdate()
		},

		onModalClose(e) {
			this.$root.$emit('order_modal_closed')
			this.$forceUpdate()
		},
	},

	render() {
		let OrderModal = lo.get(this.OrderModal, 'default', null)
		return (
			<OrderModal
				cid={this.cid}
				no_change_user={lo.get(this.$root.$orderOption(), 'no_change_user', false)}
				show={this.$root.$isShowOrder()}
				vOn:submit={this.onModalClose}
				order={this.$root.$order()}
				vOn:change={this.onChangeOrder}
				vOn:close={this.onModalClose}
			/>
		)
	},
}
